import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';

import { Price } from './Price';
import { getFormattedPriceType, getPriceCaption } from './utiles';
import { PriceContainerProps } from './types';

export const PriceContainer: React.FC<PriceContainerProps> = props => {
  const isMobile = useDeviceType() === 'phone';

  const { price = 0, area = 0, priceType, paymentPeriod, isSale } = props;

  const priceTypeWithPaymentPeriod = getFormattedPriceType(priceType, paymentPeriod, isSale);

  const priceCaption = React.useMemo(
    () => getPriceCaption(price, area, priceTypeWithPaymentPeriod),
    [area, priceTypeWithPaymentPeriod, price],
  );

  const captionColor = React.useMemo(() => (price ? 'black_100' : 'gray60_100'), [price]);

  return (
    <Price
      {...props}
      priceType={priceTypeWithPaymentPeriod}
      isMobile={isMobile}
      priceCaption={priceCaption}
      captionColor={captionColor}
    />
  );
};
